module.exports = __webpack_public_path__ + "default-img-686aa412.png";